import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

export const Loader: React.FC = () => (
  <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
)
